import type { SeoPageConfig } from './seo-page-config';

const privatePage = (title: string): SeoPageConfig => ({
  title,
  description: 'Private customer page on Unaavu.',
  robots: 'noindex, nofollow',
});

/** Route `data.seo` entries for transactional / private flows (Phase 1). */
export const SEO_ROUTE_DATA = {
  myOrders: privatePage('My orders | Unaavu'),
  orderSuccess: privatePage('Order confirmation | Unaavu'),
  orderFailure: privatePage('Order issue | Unaavu'),
  reservationSuccess: privatePage('Reservation confirmed | Unaavu'),
  reservationFailure: privatePage('Reservation issue | Unaavu'),
  tableLanding: privatePage('Table ordering | Unaavu'),
  tableBill: privatePage('Table bill | Unaavu'),
  preOrder: privatePage('Pre-order | Unaavu'),
  authCallback: privatePage('Sign in | Unaavu'),
  campaignRedirect: privatePage('Loading | Unaavu'),
} as const;
